import { Grid, Card, CardContent, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function KpiSummary({data}) {
  const { t } = useTranslation();

  const summary = [
    { label: t('message.common.subtitle.activity.userCount'), value: data?.userCount },
    { label: t('message.common.subtitle.activity.pageViewCount'), value: data?.pageViewCount },
    { label: t('message.common.subtitle.activity.workCount'), value: data?.workCount },
  ];

  return (
    <Grid container spacing={2}>
      {summary.map((item, idx) => (
        <Grid item xs={4} key={idx} >
          <Card sx={{ borderRadius: 2, textAlign:"center", height:"100px" }}>
            <CardContent>
              <Typography variant="body2" color="text.secondary" sx={{height : "30px", fontSize:"20px", marginTop:"5px"}}>
                {item.label}
              </Typography>
              <Typography variant="h5" sx={{ mt: 1, fontSize:"35px" }}>
                {item.value}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}